import Cancel from './Cancel'
import Create from './Create'
import Delete from './Delete'
import Edit from './Edit'
import Error from './Error'
import ErrorDetails from './ErrorDetails'
import Success from './Success'
import Loading from './Loading'
export { Cancel, Create, Delete, Edit, Error, ErrorDetails, Success, Loading }
